module.exports = __webpack_public_path__ + "static/media/jeannelyn.1ce2927b.png";